var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-eye_closed_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), /*#__PURE__*/React.createElement("g", {
    id: "eye_closed_1",
    "data-name": "eye_closed \\u2013 1",
    clipPath: "url(#clip-eye_closed_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UNHide_Team",
    "data-name": "UNHide Team",
    transform: "translate(-156.061 -398.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_71",
    "data-name": "Subtraction 71",
    d: "M5365.519,2648.6c-3.972,0-7.827-2.361-11.458-7.018l0-.006a20.187,20.187,0,0,1,3.209-3.538c.271-.237.549-.465.825-.679l3.025,3.025a4.491,4.491,0,0,0,5.6,5.6l2.083,2.083A10.618,10.618,0,0,1,5365.519,2648.6Zm7.023-2.454h0l-2.909-2.909a4.49,4.49,0,0,0-5.767-5.766l-2.2-2.2a10.629,10.629,0,0,1,3.931-.781c3.972,0,7.845,2.4,11.514,7.129l0,.006a20.457,20.457,0,0,1-3.236,3.484c-.439.375-.887.723-1.331,1.034Z",
    transform: "translate(-5195 -2227.607)",
    fill: "#8bc500",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 2,
    height: 26,
    transform: "translate(179.253 423.083) rotate(135)",
    fill: "#8bc500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.0e977852e67070cab76f90ac77506745.svg";
export { ForwardRef as ReactComponent };